/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InternalApiPersonScreeningAuditEvent
 */
export interface InternalApiPersonScreeningAuditEvent {
    /**
     * 
     * @type {string}
     * @memberof InternalApiPersonScreeningAuditEvent
     */
    flowId?: string;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiPersonScreeningAuditEvent
     */
    latestScreening?: Date;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiPersonScreeningAuditEvent
     */
    startTime: Date;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiPersonScreeningAuditEvent
     */
    endTime?: Date;
}

/**
 * Check if a given object implements the InternalApiPersonScreeningAuditEvent interface.
 */
export function instanceOfInternalApiPersonScreeningAuditEvent(value: object): value is InternalApiPersonScreeningAuditEvent {
    if (!('startTime' in value) || value['startTime'] === undefined) return false;
    return true;
}

export function InternalApiPersonScreeningAuditEventFromJSON(json: any): InternalApiPersonScreeningAuditEvent {
    return InternalApiPersonScreeningAuditEventFromJSONTyped(json, false);
}

export function InternalApiPersonScreeningAuditEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiPersonScreeningAuditEvent {
    if (json == null) {
        return json;
    }
    return {
        
        'flowId': json['flowId'] == null ? undefined : json['flowId'],
        'latestScreening': json['latestScreening'] == null ? undefined : (new Date(json['latestScreening'])),
        'startTime': (new Date(json['startTime'])),
        'endTime': json['endTime'] == null ? undefined : (new Date(json['endTime'])),
    };
}

export function InternalApiPersonScreeningAuditEventToJSON(json: any): InternalApiPersonScreeningAuditEvent {
    return InternalApiPersonScreeningAuditEventToJSONTyped(json, false);
}

export function InternalApiPersonScreeningAuditEventToJSONTyped(value?: InternalApiPersonScreeningAuditEvent | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'flowId': value['flowId'],
        'latestScreening': value['latestScreening'] == null ? value['latestScreening'] : value['latestScreening'].toISOString(),
        'startTime': value['startTime'].toISOString(),
        'endTime': value['endTime'] == null ? value['endTime'] : value['endTime'].toISOString(),
    };
}

